import { AfterContentInit, Inject } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Enumerable from 'linq';
import { CallHttpService, DialogVestaService } from '@vesta/vesta';
import { CallsAnalisisService } from '../../services/calls-analisis.service';
import { CorteDiarioModel } from '../corte-diario.models';
import { GridRutasComponent } from '../grid-rutas/grid-rutas.component';
import { ModalCambiarFronteraComponent } from '../modal-cambiar-frontera/modal-cambiar-frontera.component';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'modal-crear-plantilla',
  templateUrl: './modal-crear-plantilla.component.html',
  styleUrls: ['./modal-crear-plantilla.component.css'],
})
export class ModalCrearPlantillaComponent implements OnInit, AfterContentInit {
  //este componente es reciclado para crear y actualiazr la plantilla
  constructor(
    private serviceanalisis: CallsAnalisisService,
    private dialogService: DialogVestaService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      //GestionesXRuta: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>,
      plantillaSelected: CorteDiarioModel.PlantillasIndex;
      UsuarioId: string;
      isEdit: boolean;
      RutasXUsuario: Array<CorteDiarioModel.RutasByUsuario>;
    }
  ) {}

  //@ViewChild("GridRutas", { static: false }) GridRutas: GridRutasComponent = new GridRutasComponent;
  @ViewChild(GridRutasComponent, { static: false })
  GridRutas: GridRutasComponent;

  public UsuarioId: string = '';
  public titleModal: string = '';
  public searchTermRuta: string = null;
  public searchTermSku: string = null;

  public Reload: boolean = false;
  public isCheckedAll: boolean = false;

  public createPlantilla: CorteDiarioModel.PlantillaCoU;
  public listRutas: Array<CorteDiarioModel.listRutasGrid> = [];
  public listRutasCopy: Array<CorteDiarioModel.listRutasGrid> = [];
  public listSkusFilter: Array<CorteDiarioModel.DetalleFactura> = [];
  public listrutasXUsuario: Array<CorteDiarioModel.RutasByUsuario> = [];
  public listrutasXUsuarioCopy: Array<CorteDiarioModel.RutasByUsuario> = [];
  public listGestionXRuta: Array<CorteDiarioModel.GetGestionesAbiertasXRutas> =
    [];
  public listrutasXUsuarioCopySitios: Array<CorteDiarioModel.RutasByUsuario> =
    [];
  public listSitios: Array<any> = [];
  public sitioSeleccionado: string | null = null;
  public sitios: { Nombre: string }[] = [];

  ngOnInit(): void {
    this.UsuarioId = this.data.UsuarioId;
    //this.listGestionXRuta = this.data.GestionesXRuta;
    this.createPlantilla = {
      NombrePLantilla: '',
      CreatedById: '',
      DiasAntesxFechaUltimoSello: 0,
      EsPublica: true,
      Rutas: [],
      UsuarioId: '',
      DiaMax: 0,
      DiaMin: 0,
      Favorita: false,
    };
  }

  ngAfterContentInit(): void {
    //cada vez que entre a este componente verificara si existe esta data
    //para no recargar el metodo

    //this.listGestionXRuta = JSON.parse(localStorage.getItem('gesionByRutasAll'))
    //if (this.listGestionXRuta != null && this.listGestionXRuta != undefined) {
    //  if (this.listGestionXRuta.length > 0) {
    //    this.ngData(this.listGestionXRuta)

    //  }
    //} else {
    //  let rutas = Enumerable.from(this.data.RutasXUsuario).select(s => s.Id).toArray();
    //  this.GetGestionesAbiertasXRutas(rutas);

    //}

    //this.ngData(this.listGestionXRuta)
    this.ngDataGridRutas();
    this.titleModal = this.data.isEdit ? 'EDITAR PLANTILLA' : 'CREAR PLANTILLA';
  }

  ngDataGridRutas() {
    let listSitios = [];

    this.data.RutasXUsuario.forEach((RutaU) => {
      // Asignar sitio de aduana si existe
      RutaU.AduanaEnSitio = Enumerable.from(RutaU.SitiosPorRuta)
        .where((r) => r.Sitio.EsAduana == true)
        .select((r) => r.Sitio.Nombre)
        .firstOrDefault();

      //toma los sitios de la ruta padre
      RutaU.listSitios = Enumerable.from(RutaU.SitiosPorRuta)
        .takeExceptLast()
        .toArray();
      //tomar siutios de rutas hijas excepto los ultimos
      if (RutaU.RutaCompuesta.length > 0) {
        //itera cada ruta hija
        RutaU.RutaCompuesta.forEach((rutah, index) => {
          //itera lossitios para insertarlos en el array
          rutah.SitiosPorRuta.forEach((sitiosRH, indexS) => {
            //si llega al ultimo index, no lo agrega,porque es el destino de la ruta hija
            if (indexS != rutah.SitiosPorRuta.length - 1) {
              RutaU.listSitios.push(sitiosRH);
            }
          });
        });
        RutaU.listSitios = Enumerable.from(RutaU.listSitios)
          .distinct((s) => s.Id)
          .toArray();
      }

      // Filtrar sitios duplicados en la lista final de sitios
      RutaU.listSitios = Enumerable.from(RutaU.listSitios)
        .distinct((s) => s.SitioId)
        .toArray();
      RutaU.listSitios = [...RutaU.listSitios];
      listSitios.push(...RutaU.listSitios);

      // Inicializar campos adicionales
      RutaU.Selected = false;
      RutaU.SitioReferenciaId = null;

      // Si está en modo edición y hay una plantilla seleccionada
      if (
        this.data.isEdit &&
        this.data.plantillaSelected != undefined &&
        this.data.plantillaSelected != null
      ) {
        // Verificar si la ruta está seleccionada en la plantilla
        RutaU.Selected = this.data.plantillaSelected.TemplateRutas.some(
          (ruta) => ruta.Ruta.Id == RutaU.Id
        );

        // Obtener SitioReferenciaId si está en la plantilla seleccionada
        RutaU.SitioReferenciaId = Enumerable.from(
          this.data.plantillaSelected.TemplateRutas
        )
          .where((RutaZ) => RutaZ.Ruta.Id == RutaU.Id)
          .select((s) => s.SitioReferenciaId)
          .firstOrDefault();
      }
    });

    //Filtrar por pais las rutas
    // this.data.RutasXUsuario = Enumerable.from(this.data.RutasXUsuario)
    //   .where(
    //     (r) =>
    //       r.SitiosPorRuta.filter(
    //         (s) => s.Sitio.PaisId == '65507ecf-249e-454b-a95a-0061ba0fa2ba'
    //       ).length > 0
    //   )
    //   .toArray();

    // Crear copias de la lista de rutas para el usuario
    this.listrutasXUsuario = [...this.data.RutasXUsuario];
    this.listrutasXUsuarioCopySitios = [...this.data.RutasXUsuario];
    this.listrutasXUsuarioCopy = [...this.data.RutasXUsuario];

    // this.listSitios = Enumerable.from(listSitios)
    //   .select((item) => ({
    //     Id: item.Sitio.Id,
    //     Nombre: item.Sitio.Nombre,
    //   }))
    //   .toArray();

    this.listSitios = Enumerable.from(listSitios)
      .distinct((item) => item.Sitio.Id) // Elimina duplicados basados en el campo `Id`
      .select((item) => ({
        Id: item.Sitio.Id,
        Nombre: item.Sitio.Nombre,
      }))
      .toArray();

    this.listSitios = [
      { Id: null, Nombre: 'Borrar Toda la Selección' },
      ...this.listSitios,
    ];

    // Imprimir la lista de rutas

    // Si está en modo edición, preparar la plantilla para edición
    if (
      this.data.isEdit &&
      this.data.plantillaSelected != undefined &&
      this.data.plantillaSelected != null
    ) {
      this.createPlantilla = {
        TemplateId: this.data.plantillaSelected.Id,
        NombrePLantilla: this.data.plantillaSelected.Nombre,
        ModifiedBy: this.UsuarioId,
        DiasAntesxFechaUltimoSello:
          this.data.plantillaSelected.DiasAntesxFechaUltimoSello,
        EsPublica: this.data.plantillaSelected.EsPublica,
        Rutas: [],
        UsuarioId: this.UsuarioId,
        DiaMax: this.data.plantillaSelected.DiaMax,
        DiaMin: this.data.plantillaSelected.DiaMin,
        Favorita: this.data.plantillaSelected.Favorita,
      };
    }
  }

  ngData(gestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas>) {
    this.listRutas = [];
    let listskus: CorteDiarioModel.DetalleFactura[] = [];
    let gestionesbyruta = Enumerable.from(gestiones)
      .groupBy((s) => s.Ruta.NombreRuta)
      .toArray();
    gestionesbyruta.forEach((gestion) => {
      let rutaGestion = gestion.getSource();

      let isSelected = false;
      if (
        this.data.isEdit &&
        this.data.plantillaSelected != undefined &&
        this.data.plantillaSelected != null
      ) {
        //Fue seleccionada una plantilla para editarse
        isSelected = this.data.plantillaSelected.TemplateRutas.some(
          (ruta) => ruta.Ruta.Id == rutaGestion[0].Ruta.Id
        );
      }

      listskus = Enumerable.from(rutaGestion)
        .selectMany((s) => s.CostosFacturacion)
        .selectMany((s) => s.DetalleFactura)
        .toArray();

      listskus.forEach((sku) => {
        sku.ConcatSkuDescr = sku.CodigoSku + ' ' + sku.ProductoDescripcion;
        this.listSkusFilter.push(sku);
      });
      this.listRutas.push({
        RutaId: rutaGestion[0].Ruta.Id,
        Ruta: rutaGestion[0].Ruta.NombreRuta,
        Gestion: rutaGestion.length,
        SKU: Enumerable.from(rutaGestion)
          .selectMany((s) => s.CostosFacturacion)
          .select((s) => s.DetalleFactura)
          .toArray().length,
        Aduana: Enumerable.from(rutaGestion[0].Ruta.SitiosPorRuta)
          .where((s) => s.EsAduana == true)
          .select((s) => s.Nombre)
          .firstOrDefault(),
        Selected: isSelected,
        ListSkus: listskus,
      });
    });
    //si no existe al menos una gestion con alguna de las rutas del usuario, agregarla y ponerla en cero los datos
    this.data.RutasXUsuario.forEach((ruta) => {
      if (
        !this.listRutas.some(
          (s) => s.RutaId.toLowerCase() == ruta.Id.toLowerCase()
        )
      ) {
        let isSelected = false;
        if (
          this.data.isEdit &&
          this.data.plantillaSelected != undefined &&
          this.data.plantillaSelected != null
        ) {
          //Fue seleccionada una plantilla para editarse
          isSelected = this.data.plantillaSelected.TemplateRutas.some(
            (rutaS) => rutaS.Ruta.Id == ruta.Id
          );
        }

        this.listRutas.push({
          RutaId: ruta.Id,
          Ruta: ruta.NombreRuta,
          Gestion: 0,
          SKU: 0,
          Aduana: Enumerable.from(ruta.SitiosPorRuta)
            .where((s) => s.Sitio.EsAduana == true)
            .select((s) => s.Sitio.Nombre)
            .firstOrDefault(),
          Selected: isSelected,
          ListSkus: [],
        });
      }
    });

    this.listSkusFilter = Enumerable.from(this.listSkusFilter)
      .distinct((s) => s.CodigoSku)
      .toArray();
    this.listRutasCopy = [...this.listRutas];
    if (
      this.data.isEdit &&
      this.data.plantillaSelected != undefined &&
      this.data.plantillaSelected != null
    ) {
      //Fue seleccionada una plantilla para editarse
      this.createPlantilla = {
        TemplateId: this.data.plantillaSelected.Id,
        NombrePLantilla: this.data.plantillaSelected.Nombre,
        ModifiedBy: this.UsuarioId,
        DiasAntesxFechaUltimoSello:
          this.data.plantillaSelected.DiasAntesxFechaUltimoSello,
        EsPublica: this.data.plantillaSelected.EsPublica,
        //SitioAduanaId: this.data.plantillaSelected.SitioAduanaId,
        Rutas: [],
        UsuarioId: this.UsuarioId,
        DiaMax: this.data.plantillaSelected.DiaMax,
        DiaMin: this.data.plantillaSelected.DiaMin,
        Favorita: this.data.plantillaSelected.Favorita,
      };
    }
  }

  FilterRutas() {
    if (this.searchTermRuta === null && this.searchTermSku === null) {
      this.listRutas = [...this.listRutasCopy];
    } else {
      this.listRutas = this.listRutasCopy.filter((ruta) => {
        // Filtrar usuarios que coincidan con el término de búsqueda
        return (
          ruta.Ruta.toLowerCase().startsWith(
            this.searchTermRuta?.toLowerCase()
          ) || ruta.ListSkus.some((sku) => sku.CodigoSku == this.searchTermSku)
        );
      });
    }
  }

  FilterRutasInput() {
    if (this.searchTermRuta === null) {
      this.listrutasXUsuario = [...this.listrutasXUsuarioCopy];
    } else {
      this.listrutasXUsuario = this.listrutasXUsuarioCopy.filter((ruta) =>
        ruta.NombreRuta.toLowerCase().includes(
          this.searchTermRuta.toLowerCase()
        )
      );
    }
  }

  onSelectChange(event) {
    this.listrutasXUsuario.forEach((sitio) => {
      if (sitio.listSitios.some((s) => s.Sitio.Id == event.Id)) {
        sitio.SitioReferenciaId = event.Id;
      } else if (event.Nombre == 'Borrar Toda la Selección') {
        sitio.SitioReferenciaId = null;
      }
    });
  }

  EventSelectAll() {
    if (this.isCheckedAll) {
      this.listrutasXUsuario.forEach((s) => (s.Selected = true));
    } else {
      this.listrutasXUsuario.forEach((s) => (s.Selected = false));
    }
    this.listrutasXUsuario = [...this.listrutasXUsuario];
  }

  countSelected() {
    return this.listrutasXUsuario.filter((item) => item.Selected).length;
  }

  EventChangeFronteraModal() {
    const dialogRef = this.dialog.open(ModalCambiarFronteraComponent, {
      width: '40%', // Ancho del diálogo
      height: '50%', // Alto del diálogo
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      //console.log(`Dialog result: ${result}`);
    });
  }

  EventGuardar() {
    if (!this.data.isEdit) {
      //crear
      this.PostPlantillaCreate();
    } else {
      //actualizar
      this.PostPlantillaUpdate();
    }
  }

  GetGestionesAbiertasXRutas(rutas: string[]) {
    let query = {
      rutaId: rutas,
      sitioAduanaId: null,
      diasAntesxFechaUltimoSello: null,
    };
    this.serviceanalisis
      .GetGestionesAbiertasXRutas(query)
      .then((result) => {
        result.forEach((gestion) => {
          gestion.TiempoProceso = parseFloat(gestion.TiempoProceso.toFixed(2));
        });
        this.listGestionXRuta = result;

        this.ngData(this.listGestionXRuta);
        // this.openDialog(plantilla);

        //Guardamos las rutas ya estructuradas del grid
        //cada vez que entre a este componente verificara si existe esta data
        //para no recargar el metodo
        localStorage.setItem(
          'gesionByRutasAll',
          JSON.stringify(this.listGestionXRuta)
        );
      })
      .catch((e) => {
        this.dialogService.NotificacionAlert(e);
      });
  }

  PostPlantillaCreate() {
    let rutas = Enumerable.from(this.listrutasXUsuario)
      .where((s) => s.Selected == true)
      .toArray();
    rutas.forEach((r) => {
      this.createPlantilla.Rutas.push({
        rutaId: r.Id,
        SitioReferenciaId: r.SitioReferenciaId,
      });
    });
    this.createPlantilla.CreatedById = this.UsuarioId;
    //this.createPlantilla.SitioAduanaId = null;
    this.createPlantilla.DiasAntesxFechaUltimoSello = 1;
    this.createPlantilla.UsuarioId = this.UsuarioId;

    this.serviceanalisis
      .PostPlantillasCreate(this.createPlantilla)
      .then((result) => {
        if (result) {
          if (this.createPlantilla.Favorita) {
            this.PostPlantillaCreateFAv(result.Message.Id);
          } else {
            this.Reload = true;
            this.CerrarModal();
          }

          this.dialogService.NotificacionSuccess(
            'Plantilla creada correctamente'
          );
        }
      })
      .catch((e) => {
        this.dialogService.NotificacionAlert(e);
      });
  }

  PostPlantillaUpdate() {
    let rutas = Enumerable.from(this.listrutasXUsuario)
      .where((s) => s.Selected == true)
      .toArray();
    rutas.forEach((r) => {
      this.createPlantilla.Rutas.push({
        rutaId: r.Id,
        SitioReferenciaId: r.SitioReferenciaId,
      });
    });
    this.createPlantilla.DiaMax =
      this.createPlantilla.DiaMax == 0 ? null : this.createPlantilla.DiaMax;
    this.createPlantilla.DiaMin =
      this.createPlantilla.DiaMin == 0 ? null : this.createPlantilla.DiaMin;

    this.serviceanalisis
      .PostPlantillasUpdate(this.createPlantilla)
      .then((result) => {
        if (result) {
          //if (this.createPlantilla.Favorita) {
          this.PostPlantillaCreateFAv(result.Message.Id);

          //} else {
          //  this.Reload = true;
          //  this.CerrarModal();

          //};

          this.dialogService.NotificacionSuccess(
            'Plantilla Actualizada correctamente'
          );
        }
      })
      .catch((e) => {
        this.dialogService.NotificacionAlert(e);
      });
  }

  PostPlantillaCreateFAv(idPlantilla: string) {
    let query = {
      templateId: idPlantilla,
      favorita: this.createPlantilla.Favorita,
      modifiedBy: this.UsuarioId,
    };

    this.serviceanalisis
      .PostPlantillasFav(query)
      .then((result) => {
        if (result) {
          this.Reload = true;
          this.CerrarModal();
        }
      })
      .catch((e) => {
        this.dialogService.NotificacionAlert('Plantilla Favorita Error=  ' + e);
      });
  }

  CerrarModal() {
    this.dialog.closeAll();
  }
}
